import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Image from 'next/image';
import { API } from '_helpers';

const SHADOW =
  '0 -4px 150px rgba(104,119,251,.1), 64px 1px 150px rgba(251,107,104,.1)';

interface Props {
  data: CSection4;
}

const Section4: React.FC<Props> = ({ data }) => {
  return (
    <Container sx={{ py: 10 }}>
      <Stack spacing={4}>
        <Typography
          variant="h1"
          sx={{
            width: { xs: 1, sm: 0.7, md: 0.5 },
            ml: { xs: 0, sm: 10, md: 20 },
            my: 4,
          }}
        >
          {data?.title}
        </Typography>
        <Box>
          <Grid container spacing={4}>
            <Grid item xs={12} md={5}>
              <Stack
                justifyContent="space-between"
                sx={{
                  width: 1,
                  height: 1,
                  bgcolor: '#060d20',
                  borderRadius: 6,
                  boxShadow: SHADOW,
                  p: 4,
                }}
                spacing={4}
              >
                <Typography>{data?.card1?.subtitle}</Typography>
                <Stack sx={{ width: 1, height: 300, position: 'relative' }}>
                  <Image
                    alt={data?.card1?.media?.alternativeText}
                    src={`${API}${data?.card1?.media.url}`}
                    layout="fill"
                    objectFit="contain"
                  />
                </Stack>
                <Typography variant="h1">{data?.card1?.title}</Typography>
                <Typography color="text.secondary">
                  {data?.card1?.description}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={7}>
              <Grid item container spacing={4}>
                <Grid item xs={12}>
                  <Stack
                    direction={{ xs: 'column-reverse', md: 'row' }}
                    sx={{
                      width: 1,
                      height: { xs: 'auto', md: 350 },
                      bgcolor: '#060d20',
                      borderRadius: 6,
                      boxShadow: SHADOW,
                      p: 4,
                    }}
                    spacing={4}
                  >
                    <Stack justifyContent="space-between" sx={{ width: 1 }}>
                      <Typography>{data?.card2?.subtitle}</Typography>
                      <Typography variant="h2">{data?.card2?.title}</Typography>
                      <Typography color="text.secondary">
                        {data?.card2?.description}
                      </Typography>
                    </Stack>
                    <Stack sx={{ width: 1, height: 300, position: 'relative' }}>
                      <Image
                        alt={data?.card2?.media?.alternativeText}
                        src={`${API}${data?.card2?.media.url}`}
                        layout="fill"
                        objectFit="contain"
                      />
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={12} lg={6}>
                  <Stack
                    sx={{
                      width: 1,
                      height: 420,
                      bgcolor: '#060d20',
                      borderRadius: 6,
                      boxShadow: SHADOW,
                      p: 4,
                    }}
                    spacing={4}
                  >
                    <Typography>{data?.card3?.subtitle}</Typography>
                    <Stack spacing={3}>
                      <Typography variant="h2">{data?.card3?.title}</Typography>
                      <Typography color="text.secondary">
                        {data?.card3?.description}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={12} lg={6}>
                  <Stack
                    sx={{
                      width: 1,
                      height: 420,
                      bgcolor: '#060d20',
                      borderRadius: 6,
                      boxShadow: SHADOW,
                      p: 4,
                    }}
                    spacing={3}
                  >
                    <Typography>{data?.card4?.subtitle}</Typography>
                    <Stack spacing={3}>
                      <Typography variant="h2">
                        {data?.card4?.subtitle}
                      </Typography>
                      <Typography color="text.secondary">
                        {data?.card4?.description}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Stack>
    </Container>
  );
};

export default Section4;
